import { render, staticRenderFns } from "./PaymentMethodsLoader.vue?vue&type=template&id=4a68c778&scoped=true"
import script from "./PaymentMethodsLoader.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsLoader.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodsLoader.vue?vue&type=style&index=0&id=4a68c778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a68c778",
  null
  
)

export default component.exports